module.exports = __webpack_public_path__ + "img/start-icon.b29a1377.svg";